import { Swiper } from "swiper";
import { Navigation, Pagination, Keyboard, EffectFade, FreeMode } from "swiper/modules";
import "swiper/css";
import 'swiper/css/effect-fade';

export default function initSwiper() {
    const swipers = document.querySelectorAll(".swiper-component");
    
    if (!swipers) return;
    
    swipers.forEach((swiper) => {
        const data = swiper.dataset

        const calculateOffset = (swiperInstance) => {
            if (data.type === "article-gallery") {
                const swiperWrapper = swiper.querySelector('.swiper-wrapper');
            
                if (swiperWrapper) {
                    const transform = window.getComputedStyle(swiperWrapper).transform;
                    
                    if (transform && transform !== 'none') {
                        const matrix = new DOMMatrix(transform);
                        const translateX = matrix.m41; // m41 is the translateX value
                        
                        const swiperElement = swiper.querySelector('.swiper');
                        swiperElement.style.setProperty('--swiper-offset', `${-translateX}px`);
                    }
                }
            }
        };

        const swiperInstance = new Swiper(swiper.querySelector(".swiper"), {
            modules: [Navigation, Pagination, Keyboard, EffectFade, FreeMode],
            effect: "slide",
            draggable: true,
            grabCursor: true,
            allowTouchMove: true,
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },
            navigation: {
                nextEl: swiper.querySelector(".swiper-button-next"),
                prevEl: swiper.querySelector(".swiper-button-prev"),
                disabledClass: "disabled",
            },
            pagination: {
                el: swiper.querySelector(".swiper-pagination"),
                type: "fraction",
                renderFraction: (currentClass, totalClass) => {
                    return `<span class="${currentClass}"></span>` +
                        ' / ' +
                        `<span class="${totalClass}"></span>`;
                },
                formatFractionCurrent: (number) => {
                    return number < 10 ? `0${number}` : number;
                },
                formatFractionTotal: (number) => {
                    if (data.type === "article-gallery") {
                        const slideCount = swiper.querySelectorAll('.swiper-slide').length;
                        return slideCount < 10 ? `0${slideCount}` : slideCount;
                    }
                    return number < 10 ? `0${number}` : number;
                }
            },
            slidesPerView: data.type === "personnel" ? 1.15 : (data.type === "article-gallery" ? "auto" : 1),
            spaceBetween: data.type === "personnel" ? 25 : 27,
            freeMode: data.type === "personnel",
            centeredSlides: data.type === "article-gallery",
            breakpoints: {
                480: {
                    slidesPerView: data.type === "personnel" ? 1.75 : (data.type === "article-gallery" ? "auto" : 1),
                },
                768: {
                    slidesPerView: data.type === "personnel" ? 2.5 : (data.type === "article-gallery" ? "auto" : 1),
                },
                1024: {
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true, // Optional: Enable cross-fade
                    },
                    slidesPerView: data.type === "personnel" ? 2.5 : (data.type === "article-gallery" ? "auto" : 1),
                    slidesPerGroup: data.type === "personnel" ? 2 : 1,
                },
                1200: {
                    slidesPerView: data.type === "personnel" ? 3.22 : (data.type === "article-gallery" ? "auto" : 1),
                    slidesPerGroup: data.type === "personnel" ?  3 : 1,
                    freeMode: false,
                },
            },
            on: {
                init: function() {
                    calculateOffset(this);
                },
                slideChange: function() {
                    if (data.type === "article-gallery") {
                        this.pagination.update();
                    }
                }
            }
        });
        // Resize event listener for article-gallery swipers
        if (data.type === "article-gallery") {
            let resizeTimeout;
            
            window.addEventListener('resize', () => {
                clearTimeout(resizeTimeout);
                resizeTimeout = setTimeout(() => {
                    setTimeout(() => {
                        calculateOffset(swiperInstance);
                    }, 100);
                }, 250);
            });
        }
    });
}